module.exports = __webpack_public_path__ + "static/media/DomainWest.cf62a8aa.jpg";